import { useQuery } from '@tanstack/vue-query';
import apiInterceptor from '@/shared/apiInterceptor';
import { environment } from '@/shared/env';

export const teamMembersQueryOptions = {
  queryKey: ['team-members'],
  queryFn: async () => {
    const r = await apiInterceptor.get(environment('VUE_APP_API_URL') + 'roles/v1/team_members/');
    return Array.isArray(r) ? r : (r?.data || []);
  },
  staleTime: Infinity,
};

export function useTeamMembers() {
  return useQuery(teamMembersQueryOptions);
}
